<app-modal
  [title]="'features.plan.deploy.picker.title' | translate"
  [size]="ModalSize.XXL"
  [config]="modalConfig()"
  (closeModal)="cancelled.emit()">
  <div modal-body class="flex flex-col gap-2">
    @if (candidates().length === 0) {
      <p class="text-text-secondary py-6 text-center text-xs">
        {{ 'features.plan.deploy.picker.empty' | translate }}
      </p>
    } @else {
      <p class="text-text-tertiary text-[10.5px]">
        {{
          'features.plan.deploy.picker.selected_count' | translate: { count: draft().size }
        }}
      </p>

      @if (entityType(); as type) {
        <app-toolbox
          [searchConfig]="toolboxSearchConfig()"
          [showPageSelector]="true"
          [paginationConfig]="pagination()"
          (pageChange)="onPageChange($event)"
          [(searchQuery)]="searchQuery"
          (advancedQuerySearch)="onAdvancedQuerySearch($event)"
          [showCustomContent]="activeGrammar() === 'path'"
          class="text-text-primary">
          @if (activeGrammar() === 'path' && pathBar.vocabulary(); as vocab) {
            <app-path-filter-search-bar
              class="min-w-80 flex-1"
              [vocabulary]="vocab"
              [state]="pathBar.bar()"
              (stateChange)="pathBar.editBar($event)" />
          }
        </app-toolbox>

        @if (activeGrammar() === 'path' && pathBar.vocabulary(); as vocab) {
          <app-path-filter-pills
            class="border-weak bg-elevated block border-b"
            [vocabulary]="vocab"
            [draft]="pathBar.draft()"
            [invalidPaths]="pathBar.invalidPaths()"
            (draftChange)="pathBar.editDraft($event)"
            (openAdvanced)="pathBar.pathPanel.set('filter')">
            <app-path-filter-sort
              [vocabulary]="vocab"
              [sort]="pathBar.sort()"
              (sortChange)="pathBar.editSort($event)" />
          </app-path-filter-pills>
        } @else {
          <app-filter-query-builder
            [availableFields]="availableFilterFields()"
            [initialConfiguration]="userFilter()"
            [openFilterForField]="openFilterForField()"
            (filterChange)="onFilterChange($event)" />
        }

        <!-- A definite height, not a max: the table is `height: 100%` over a `flex-1
             min-h-0` body, so an indefinite parent collapses its rows to nothing. The
             listing column stretches to that height beside the docked filter panel. -->
        <div class="border-default flex h-[55vh] overflow-hidden rounded-sm border">
          <div class="flex min-h-0 min-w-0 flex-1 flex-col">
            @if (failed()) {
              <p data-testid="picker-error" class="text-danger py-6 text-center text-xs">
                {{ 'features.plan.deploy.picker.load_error' | translate }}
              </p>
            } @else if (rows().length === 0) {
              <p class="text-text-secondary py-6 text-center text-xs">
                {{ 'features.plan.deploy.picker.no_results' | translate }}
              </p>
            } @else {
              <app-table
                [allColumns]="columns()"
                [data]="rows()"
                [tableId]="'deploy-entity-picker-' + type.toLowerCase()"
                [config]="tableConfig()"
                [selected]="selectedRows()"
                (sortChange)="onSortChange($event)"
                (addFilterOn)="addFilterOn($event)"
                (removeFilterOn)="removeFilterOn($event)" />
            }
          </div>
          @if (
            activeGrammar() === 'path' && pathBar.pathPanel() && pathBar.vocabulary();
            as vocab
          ) {
            <app-path-filter-panel
              appFocusFirst
              appReturnFocus
              class="h-full shrink-0"
              [title]="'features.data.path_filter.panel.title' | translate"
              [entityType]="type.toUpperCase()"
              [count]="totalEntities()"
              [error]="pathBar.error()"
              (closed)="pathBar.pathPanel.set(null)">
              <app-path-filter-composer
                panel-body
                [vocabulary]="vocab"
                [draft]="pathBar.draft()"
                [invalidPaths]="pathBar.invalidPaths()"
                (draftChange)="pathBar.editDraft($event)" />
              <div panel-footer class="flex flex-1 items-center gap-2">
                <i [class]="ICONS.checkCircle"></i>
                <span>{{ 'features.data.path_filter.panel.applied' | translate }}</span>
                <span class="flex-1"></span>
                <button
                  type="button"
                  class="btn-cancel btn-sm"
                  (click)="pathBar.clearByHand()">
                  {{ 'common.clear' | translate }}
                </button>
              </div>
            </app-path-filter-panel>
          }
        </div>
      } @else {
        <!-- No entity type: nothing to list rows from, so the uids the configuration
             already named are all there is to pick from. -->
        <ul class="border-default max-h-[50vh] overflow-y-auto rounded-sm border">
          @for (candidate of candidates(); track candidate.uid) {
            <li
              data-testid="picker-row"
              [attr.data-uid]="candidate.uid"
              class="border-weak hover:bg-interactive flex items-center gap-2 border-b px-2 py-1.5 last:border-b-0">
              <app-checkbox
                [checked]="draft().has(candidate.uid)"
                [label]="''"
                [onChange]="() => toggle(candidate.uid)" />
              <span class="shrink-0 font-mono text-xs tabular-nums">
                {{ candidate.uid }}
              </span>
              <span class="text-text-secondary truncate text-xs">
                {{ candidate.label }}
              </span>
            </li>
          }
        </ul>
      }

      @if (clearsFilterWhenEmpty() && draft().size === 0) {
        <p class="bg-warning-soft text-warning rounded-sm px-2 py-1.5 text-[10.5px]">
          {{ 'features.plan.deploy.picker.gael_clears_filter' | translate }}
        </p>
      }
    }

    <app-dropdown-singleton #localDropdown class="fixed top-0 left-0 z-300" />
  </div>
</app-modal>
